import { observable } from 'mobx';
import {
    IFlowConfigurationResponse,
    IAutoExpiration,
    IFlowConfigurationMembers
} from '~/types/model.types';

export class FlowConfigurationModel {
    @observable default_email_template_id?: string;
    @observable is_redirect_url_on?: boolean;
    @observable create_new_project?: boolean;
    @observable redirect_url?: string;
    @observable auto_expiration?: IAutoExpiration;
    @observable require_authentication?: boolean;
    @observable create_draft_from_services_selection?: boolean;
    @observable flow_template_for_draft?: string;
    @observable cta_button_text?: string;
    @observable is_logo_enabled?: boolean;
    @observable is_workflow_activated?: boolean;
    @observable is_email_confirmation_activated?: boolean;
    @observable viewer_link_sharing_enabled?: boolean;
    @observable view_only_flow_url?: string;
    @observable lead_form_contact_tag_ids?: string[];
    @observable lead_form_project_tag_ids?: string[];
    @observable
    assigned_members?: IFlowConfigurationMembers;
    @observable flow_link_slug?: string;
    @observable flow_link_slug_reached_limit?: boolean;
    @observable project_type?: string;

    constructor(flowConfiguration: IFlowConfigurationResponse) {
        if (!flowConfiguration) {
            return;
        }

        this.default_email_template_id =
            flowConfiguration.default_email_template_id;
        this.is_redirect_url_on = flowConfiguration.is_redirect_url_on;
        this.create_new_project = flowConfiguration.create_new_project;
        this.redirect_url = flowConfiguration.redirect_url;
        this.auto_expiration = flowConfiguration.auto_expiration;
        this.require_authentication = flowConfiguration.require_authentication;
        this.create_draft_from_services_selection =
            flowConfiguration.create_draft_from_services_selection;
        this.flow_template_for_draft =
            flowConfiguration.flow_template_for_draft;
        this.cta_button_text = flowConfiguration.cta_button_text;
        this.is_logo_enabled = flowConfiguration.is_logo_enabled;
        this.viewer_link_sharing_enabled =
            flowConfiguration.viewer_link_sharing_enabled;
        this.view_only_flow_url = flowConfiguration.view_only_flow_url;
        this.assigned_members = flowConfiguration.assigned_members;
        this.flow_link_slug = flowConfiguration.flow_link_slug;
        this.flow_link_slug_reached_limit =
            flowConfiguration.flow_link_slug_reached_limit;
        this.project_type = flowConfiguration.project_type;
    }
}
